import React, {
    useState,
    useEffect,
    useContext,
    useCallback,
} from 'react';

import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { useAuthentication } from 'gw-digital-auth-react';
import {
    IconButton,
    Loader,
    CurrencyField,
    CurrencyValue,
    useModal
} from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadataInternal } from '@jutro/uiconfig';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import { ClaimService } from 'gw-capability-claim';
// eslint-disable-next-line camelcase
import NagDetail_AX from '../../components/NagDetail_AX/NagDetail_AX';
import messages from './NagPage_AX.messages';
import metadata from './NagPage_AX.metadata.json5';

// eslint-disable-next-line camelcase
function NagPage_AX(props) {
    const {
        match,
        selectedPolicy,
        claimReportDTO
    } = props;
    const { params } = match;
    const { serviceRequestNumber } = params;
    const {
        showAlert,
        showConfirm
    } = useModal();
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const [isLoading, setLoadingState] = useState(false);
    const { refreshData } = useDataRefresh();
    const { isComponentValid, onValidate } = useValidation('NagPage');
    const [allNags, setNags] = useState([]);
    const [nagTotals, setNagTotals] = useState({});
    const currency = 'mxn';
    const [serviceRequest, setServiceRequest] = useState({});
    const [emptyAmount] = useState({ currency: currency, amount: 0.0 });

    const updateNagsTotals = useCallback((nags) => {
        let nagTotalNetAmountLocal = 0.00;
        let nagTotalGrossAmountLocal = 0.00;
        let nagTotalDeductibleAmountLocal = 0.00;
        _.filter(nags, (item) => item.netAmount > 0).forEach((nag) => {
            nagTotalNetAmountLocal += nag.netAmount;
            nagTotalGrossAmountLocal += nag.grossAmount;
            nagTotalDeductibleAmountLocal += nag.deductibleAmount;
        });
        _.set(nagTotals, 'netAmount.amount', nagTotalNetAmountLocal);
        _.set(nagTotals, 'grossAmount.amount', nagTotalGrossAmountLocal);
        _.set(nagTotals, 'deductibleAmount.amount', nagTotalDeductibleAmountLocal);
        setNagTotals(nagTotals);
        refreshData();
    }, [nagTotals, refreshData]);

    const handleResultNagCalculation = useCallback((nagResult, data, service) => {
        const nag = data;
        if (!nagResult.netAmount) {
            _.set(nag, 'canEdit', true);
            showAlert({
                status: 'info',
                icon: 'mi-info',
                title: messages.nagTitle,
                message: messages.nagMessage,
            });
        } else {
            _.set(nag, 'canEdit', false);
            _.set(nag, 'netAmount', nagResult.netAmount);
            _.set(nag, 'deductibleAmount', nagResult.deductibleAmount);
            _.set(nag, 'grossAmount', nagResult.grossAmount);
            if (!_.isUndefined(service)) {
                _.set(nag, 'hasPayment', service.hasPayment);
            }
        }
        return nag;
    }, []);

    const setNagsResult = useCallback(() => {
        const nagsKeys = [];
        let nagsResult = '';

        allNags.forEach((value) => {
            if (!value.canEdit) {
                nagsKeys.push(value.nagKey);
            }
        });

        nagsResult = nagsKeys.toString();
        _.set(claimReportDTO, 'nagKey', nagsResult);
    }, [allNags, claimReportDTO]);

    const calculationAmount = useCallback((data) => {
        let deductible = 0;
        let deductibleDefault = false;
        const deductibleDefaultValue = 20;
        let allowCoverage;

        const coverages = _.get(selectedPolicy, 'coverages');

        let selectedCoverages = [];
        selectedCoverages = _.filter(coverages, (item) => item.ax_Code === 'ax_CRI' || item.ax_Code === 'ax_EMACRI');

        if (selectedCoverages.length < 1) {
            selectedCoverages = _.filter(coverages, (item) => item.ax_Code === 'ax_9'
                            || item.ax_Code === 'ax_DM');
            deductibleDefault = selectedCoverages.length > 0;
        } else if (selectedCoverages.length < 1) {
            selectedCoverages = _.filter(coverages, (item) => item.ax_Code === 'ax_58'
            || item.ax_Code === 'ax_RT');
            deductibleDefault = selectedCoverages.length > 0;
        }

        if (selectedCoverages.length >= 1) {
            [allowCoverage] = selectedCoverages;
            if (deductibleDefault) {
                deductible = deductibleDefaultValue;
            } else {
                deductible = allowCoverage.deductible ? allowCoverage.deductible.amount : 0;
            }
        }

        ClaimService.nagCalculationAmount(
            data.nagKey,
            deductible,
            allowCoverage.deductibleIsPorcent ? allowCoverage.deductibleIsPorcent : false,
            authHeader
        ).then((nagResult) => {
            handleResultNagCalculation(nagResult, data, undefined);
            updateNagsTotals(allNags);
            setNagsResult();
            refreshData();
        }).catch(() => {
            showAlert({
                status: 'error',
                icon: 'mi-error',
                title: translator(messages.error),
                message: translator(messages.errorMessage)
            });
        });
    }, [allNags, authHeader, handleResultNagCalculation, refreshData, selectedPolicy,
        setNagsResult, translator, updateNagsTotals]);

    const handleFillNags = useCallback((evt, nagsToSeach,
        service, updateOnly, data) => {
        if (evt != null) {
            evt.preventDefault();
        }

        if (!_.isUndefined(nagsToSeach)) {
            if (!_.isUndefined(serviceRequestNumber)) {
                if (updateOnly) {
                    ServiceRequestService.nagCalculationAmount(
                        data.nagKey,
                        service.applyDeductiblePorcent_AX
                            ? service.deductible_Porcent_AX : service.deductible_Amount_AX,
                        service.applyDeductiblePorcent_AX,
                        service.rfc_AX,
                        authHeader
                    ).then((nagResult) => {
                        handleResultNagCalculation(nagResult, data, service);
                        updateNagsTotals(allNags);
                        refreshData();
                    }).catch(() => {
                        showAlert({
                            status: 'error',
                            icon: 'mi-error',
                            title: translator(messages.error),
                            message: translator(messages.errorMessage)
                        });
                    });
                } else {
                    ServiceRequestService.getAllNagKeys_AX(nagsToSeach,
                        service.applyDeductiblePorcent_AX
                            ? service.deductible_Porcent_AX : service.deductible_Amount_AX,
                        service.applyDeductiblePorcent_AX,
                        service.rfc_AX,
                        authHeader)
                        .then((nagsKeys) => {
                            const nagsLoad = [];
                            nagsKeys.forEach((item, key) => {
                                const nagToEdit = viewModelService.create({
                                    id: key,
                                    nagKey: item.nagKey,
                                    canEdit: false,
                                    newNag: false
                                }, 'cc', 'edge.capabilities.claim.fnol.util.NagDTO');
                                const nagLocal = handleResultNagCalculation(item, nagToEdit.value,
                                    service);
                                nagsLoad.push(nagLocal);
                            });
                            setNags([...nagsLoad]);
                            updateNagsTotals(nagsLoad);
                            refreshData();
                        });
                }
            } else {
                calculationAmount(data);
            }
        }
    }, [allNags, authHeader, calculationAmount, handleResultNagCalculation, refreshData,
        serviceRequestNumber, translator, updateNagsTotals, viewModelService]);

    const getServiceRequestDetails = useCallback(() => {
        return ServiceRequestService.getServiceRequestDetailsWithOutDocument_AX(
            serviceRequestNumber, authHeader
        );
    }, [authHeader, serviceRequestNumber]);

    useEffect(() => {
        if (!_.isUndefined(serviceRequestNumber)) {
            setLoadingState(true);
            getServiceRequestDetails().then((result) => {
                setServiceRequest(result);
                handleFillNags(null, result.referenceNumber, result, false, null);
            }).catch((error) => {
                // eslint-disable-next-line no-console
                console.log.error('Error load nags: ', error);
            }).finally(() => (setLoadingState(false)));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getId = useCallback(() => {
        const id = allNags ? allNags.length : 1;
        const existId = _.filter(allNags, (nag) => _.isEqual(nag.id, id))[0];
        if (!_.isUndefined(existId)) {
            return `${id}1`;
        }
        return id;
    }, [allNags]);

    const addNagHandler = useCallback((evt) => {
        evt.preventDefault();
        const id = getId();
        const nagLocal = viewModelService.create({
            id: id,
            canEdit: true,
            newNag: true
        }, 'cc', 'edge.capabilities.claim.fnol.util.NagDTO');
        setNags([...allNags, nagLocal.value]);
        refreshData();
    }, [getId, viewModelService, allNags, refreshData]);

    const removeNagHandler = useCallback((evt, data) => {
        evt.preventDefault();
        showConfirm({
            status: 'warning',
            icon: 'mi-warning',
            title: messages.title,
            message: messages.alertMessageWithResult,
            confirmButtonText: messages.yes,
            cancelButtonText: messages.not
        }).then((result) => {
            if (result === 'confirm') {
                const nagsToSet = _.filter(allNags, (item) => !_.isEqual(item.id, data.id));
                setNags([...nagsToSet]);
                updateNagsTotals(nagsToSet);
                refreshData();
            }
        });
    }, [allNags, refreshData, updateNagsTotals]);

    const renderDeductibleAmount = useCallback((rowData) => {
        if (_.isUndefined(rowData.deductibleAmount)) {
            return <CurrencyField id={`deductibleAmount__${rowData.id}`} value={emptyAmount.amount.value} readOnly showFractions />;
        }
        return (
            <CurrencyValue
                id={`nagDeductibleamount_${rowData.id}`}
                value={rowData.deductibleAmount}
                currency={currency}
                showFractions
                readOnly
            />
        );
    }, [emptyAmount]);
    const renderGrossAmount = useCallback((rowData) => {
        if (_.isUndefined(rowData.grossAmount)) {
            return <CurrencyValue id={`renderGrossAmount__${rowData.id}`} value={emptyAmount.amount.value} readOnly showFractions />;
        }
        return (
            <CurrencyValue
                id={`nagGrossamount_${rowData.id}`}
                currency={currency}
                showFractions
                value={rowData.grossAmount}
                readOnly
            />
        );
    }, [emptyAmount]);

    const renderNetAmount = useCallback((rowData) => {
        if (_.isUndefined(rowData.netAmount)) {
            return <CurrencyField id={`renderNetAmount__${rowData.id}`} value={emptyAmount.amount.value} readOnly showFractions />;
        }
        return <CurrencyValue id={`renderNetAmount_${rowData.id}`} currency={currency} value={rowData.netAmount} readOnly showFractions />;
    }, [emptyAmount]);

    const renderActionsContent = useCallback((data) => {
        return (
            <>
                {(_.isUndefined(data.netAmount))
                && (
                    <IconButton
                        id={`searchButton_${data.id}`}
                        icon="mi-search"
                        size="small"
                        type="filled"
                        onClick={(e) => handleFillNags(e, data.nagKey, serviceRequest, true, data)}
                    />
                )
                }
                <IconButton
                    id={`renderdeleteC__${data.id}`}
                    size="small"
                    icon="mi-delete"
                    type="outlined"
                    onClick={(e) => removeNagHandler(e, data)}
                />
            </>

        );
    }, [handleFillNags, removeNagHandler, serviceRequest]);

    const renderCellContent = useCallback((data) => {
        // eslint-disable-next-line react/jsx-pascal-case
        return <NagDetail_AX id={`nagdetail_${data.id}`} data={data} allNags={allNags} setNags={setNags} />;
    }, [allNags]);

    const updateHandler = useCallback(async () => {
        const nagsKeys = [];
        let nagsResult = '';
        allNags.forEach((value) => {
            if (!value.canEdit) {
                nagsKeys.push(value.nagKey);
            }
        });
        nagsResult = nagsKeys.toString();
        const actionDTO = viewModelService.create(
            {
                description: nagsResult,
                serviceRequestNumber: serviceRequestNumber
            },
            'cc', 'edge.capabilities.servicerequest.dto.ServiceRequestActionDTO'
        );
        return ServiceRequestService.updateReferenceNumber(actionDTO.value, authHeader);
    }, [allNags, authHeader, serviceRequestNumber, viewModelService]);

    const handleTotalChange = useCallback((newModel) => {
        setNagTotals(newModel);
        refreshData();
    }, [refreshData]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrides = {
        '@field': {
            showOptional: true
        },
        nagPageTitle: {
            content: !_.isUndefined(serviceRequestNumber)
                ? translator(messages.pageTitle) : translator(messages.pageTitleGlass)
        },
        nagResultTable: {
            data: allNags
        },
        netAmount: {
            header: translator(messages.tableNagAmount),
            renderCell: renderNetAmount
        },
        deductibleAmount: {
            header: translator(messages.tableDeductibleAmount),
            renderCell: renderDeductibleAmount
        },
        grossAmount: {
            header: translator(messages.tableGrossAmount),
            renderCell: renderGrossAmount
        },
        actionsColumn: {
            header: translator(messages.tableAction),
            renderCell: renderActionsContent
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
            renderCellContent: renderCellContent,
            addNagHandler: addNagHandler
        }
    };

    const overridesTotal = {
        nagTotalDeductibleAmountC: {
            label: translator(messages.tableDeductibleAmount)
        },
        nagTotalGrossAmountC: {
            label: translator(messages.tableGrossAmount)
        },
        nagTotalNetAmountC: {
            label: translator(messages.tableNagAmount)
        }
    };
    const resolversTotal = {
        resolveCallbackMap: {
            onValidate: onValidate
        }
    };

    const resolversUpdate = {
        resolveCallbackMap: {
            onValidate: onValidate,
            updateHandler: updateHandler
        }
    };
    const overridesUpdate = {
        updateButton: {
            enable: isComponentValid,
            content: translator(messages.updateButton),
            visible: !_.isUndefined(serviceRequestNumber)
        },
        cancellButton: {
            content: translator(messages.cancel),
            visible: !_.isUndefined(serviceRequestNumber)
        }
    };

    return (
        <>
            {renderContentFromMetadataInternal(metadata.componentContent, overrides, resolvers)}
            <ViewModelForm
                uiProps={metadata.componentTotal.content}
                model={nagTotals}
                onValidationChange={onValidate}
                onModelChange={handleTotalChange}
                overrideProps={overridesTotal}
                callbackMap={resolversTotal.resolveCallbackMap}
            />
            {renderContentFromMetadataInternal(metadata.componentUpdate, overridesUpdate, resolversUpdate)}

        </>
    );
}

export default withRouter(NagPage_AX);
